import React from 'react';
import BaseMenuOptions from './BaseMenuOptions';
import { getProfessorMenuItems } from './menuConfig';

const ProfessorMenuOptions = ({ user, isGptClassicEnabled, isOpenAIAssistantEnabled, isRagFlowAssistantEnabled, extraItems = [], activeItemId, onSelect }) => (
  <BaseMenuOptions
    items={getProfessorMenuItems({ user, isGptClassicEnabled, isOpenAIAssistantEnabled, isRagFlowAssistantEnabled, extraItems })}
    activeItemId={activeItemId}
    onSelect={onSelect}
  />
);

export default ProfessorMenuOptions;
